import React from "react";

function Footer() {
  return (
    <footer className="bg-light py-3">
      <div className="container">
        {/* Contact Information */}
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          {/* Email and Phone */}
          <div className="d-flex gap-4 mb-3 mb-md-0 align-items-center">
            <div className="d-flex align-items-center">
              <img src="/image/envelope.png" alt="email" width="20px" />
              <a
                href="mailto:eskaychinaza8@gmail.com?subject=Inquiry&body=Hi,%20I%20have%20a%20question%20about..."
                className="ms-2 text-dark text-decoration-none"
              >
                eskaychinaza8@gmail.com
              </a>
            </div>
            <div className="d-flex align-items-center">
              <img src="/image/phone.png" alt="phone" width="20px" />
              <a
                href="tel:+14699682177"
                className="ms-2 text-dark text-decoration-none"
              >
                +1 (469) 968-2177
              </a>
            </div>
          </div>

          {/* Social Media Links */}
          <ul className="list-unstyled d-flex gap-3 mb-0">
            <li className="grayscale">
              <a
                href="https://dribbble.com/chinazaeskay"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="rounded-1"
                  style={{ objectFit: "cover" }}
                  src="/image/dribble.png"
                  alt="Dribble"
                  width="25px"
                  height="25px"
                />
              </a>
            </li>
            <li className="grayscale">
              <a
                href="https://www.behance.net/chinazaeskay"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/image/behance.png" alt="Be-icon" width="20px" />
              </a>
            </li>
            {/* <li className="grayscale">
              <a
                href="https://www.instagram.com/accounts/login/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/image/instagram.png"
                  alt="instagram-icon"
                  width="20px"
                />
              </a>
            </li> */}
            {/* <li className="grayscale">
              <a
                href="https://x.com/i/flow/login?lang=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/image/twitter.png" alt="twitter-icon" width="20px" />
              </a>
            </li> */}
            <li className="grayscale">
              <a
                href="http://linkedin.com/in/chinaza-eskay-108443233"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/image/linkedin.png"
                  alt="Linkedin-icon"
                  width="20px"
                />
              </a>
            </li>
          </ul>
        </div>

        {/* Copyright */}
        <p className="text-center mt-3 mb-0 small">
          Chinaza Design{" "}
          <img src="/image/copyright.png" alt="copyright" width="11px" /> 2025
        </p>
      </div>
    </footer>
  );
}

export default Footer;
